// extracted by mini-css-extract-plugin
export var menuIcon = "_th-0";
export var menuIconInline = "_th-1";